import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { noop } from 'ui-components/default-props/noop';

import style from './delete-package-set-modal.module.less';

export const DeletePackageSetModal = ({ onDeletePackageSet = noop }) => {
  return (
    <Modal className={style['delete-package-set-modal']}>
      <ModalHeader>
        <FormattedMessage defaultMessage='Delete Package Set' description='deletePackageSetModal.title' id='38wnat' />
      </ModalHeader>
      <ModalBody className={style['modal-body']}>
        <div className={style['modal-text']}>
          <FormattedMessage
            defaultMessage='Are you sure you want to delete this package set permanently?'
            description='deletePackageSetModal.prompt'
            id='ZShcS5'
          />
        </div>
      </ModalBody>
      <ModalFooter className={style['modal-footer']}>
        <ModalFooterCancelButton />
        <Button onClick={onDeletePackageSet} theme='primary'>
          <FormattedMessage defaultMessage='Delete Package Set' description='deletePackageSetModal.delete' id='Th0uls' />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

DeletePackageSetModal.propTypes = {
  onDeletePackageSet: PropTypes.func,
};
